import { render, staticRenderFns } from "./workout-pt-appointment.vue?vue&type=template&id=19ff0328&"
import script from "./workout-pt-appointment.vue?vue&type=script&lang=js&"
export * from "./workout-pt-appointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports